import clsx from 'clsx';
import React from 'react';

import { useEventTracking } from '@hooks/index';
import { TalentTrackerSidebarItem } from '@interfaces/projects';
import { ClickTarget, click } from '@tracking';

interface SidebarSectionProps {
  className?: string;
  header: string;
  items: TalentTrackerSidebarItem[];
}

const SidebarSection = ({ className, header, items }: SidebarSectionProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <div className={clsx('w-full', className)}>
      <h2 className="mb-0 mt-0 border-0 border-b border-solid border-grayscale-gray pb-12 font-suisse-intl-mono text-feed-headline-sm text-primary-black">
        {header}
      </h2>
      {items.map(({ title, url }) =>
        url ? (
          <a
            href={url}
            className="mb-0 mt-20 block font-suisse-neue text-body-md text-primary-black underline first-of-type:mt-12 hover:text-primary-magenta dark:hover:text-primary-pink"
            key={url}
            onClickCapture={() => {
              trackEvent(
                click({
                  clickTarget: ClickTarget.AnchorLink,
                  clickLink: url,
                  clickText: title,
                })
              );
            }}
          >
            {title}
          </a>
        ) : (
          <p
            className="mb-0 mt-20 font-suisse-neue text-body-md text-primary-black first-of-type:mt-12"
            key={title}
          >
            {title}
          </p>
        )
      )}
    </div>
  );
};

export default SidebarSection;
